import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { Rule } from "../models/Rule";
import { FORM_CATEGORY } from "@/modules/FormTemplate/constants/FormTemplateConstants";

export const SERVICE_TEMP_CONSTANTS = {
  URL_ROUTE: "/service-templates",
  ADD_PAGE_TITLE: "Agregar servicio",
  PAGE_SERVICE_TITLE: "Servicios",
  FORM_TEMPLATES: "formTemplates",
  ADD_ITEM: "addItem",
  AVAILABILITY: "availability",
  BUTTON: {
    ADD_SERVICE_TEXT: "Crear servicio",
    ADD_SESSION_TEXT: "Crear sesión",
    LOAD_OPTIONS: "Cargar mas opciones",
    CONDITION_USERS: "Usuarios",
    CONDITION_PRICES: "Nivel de precio",
    CONDITION_SERVICE: "Servicio",
    CONDITION_TASK: "Tarea",
    TASKS_DATE_REF: "Fecha referencia",
    TASKS_FORM_TEMPS: "Formularios",
    TASKS_NOTIFICATIONS: "Notificaciones",
    CONDITION_ORDER: "Orden"
  },
  DIALOG_MESSAGE: {
    UPDATE: "Se ha actualizado de forma exitosa"
  },
  LABEL: {
    SUMMARY_PROMPT: "Prompt para el resumen del servicio",
    DESCRIPTION: "Descripción:",
    STATE: "Estado:",
    DATE_CREATED: "Fecha de creación:",
    DATE_CHANGED: "Fecha de modificación:",
    CREATE_AVAILABILITY: "Crear disponibilidad",
    SEL_USER_TEMP: "Elección de plantillas de usuarios*",
    SEL_LEVEL_PRICE: "Elección de nivel de precio",
    SEL_USERS: "Usuario por",
    HINT_LEVEL_PRICE: "Seleccione niveles de precio",
    HINT_USERS: "Seleccione usuarios de la lista",
    HINT_CUPS: "Escriba el nombre del CUPS y presiona enter para buscar",
    SEARCH_CUPS: "Búsqueda de cups*",
    HINT_SEARCH_USER_TEMP:
      "Escriba el nombre de la plantilla y presiona enter para buscar",
    HINT_SEARCH_USER:
      "Escriba el valor a buscar del usuario y presiona enter para buscar",
    SEARCH_USER: "Búsqueda de usuarios",
    RULE_STATE: "Estado del servicio",
    EVENT_DATE: "Fecha de referencia",
    START_DATE: "Fecha de inicio(días)",
    TIME: "Hora",
    SESSION: "Sesión*",
    GROUP: "Grupo*",
    PROGRESS_MODE: "Modo de progreso",
    PROGRESS_CONDITION: "Condición de progreso*",
    ADVANCE_ITEM_TYPE: "Tipo de elemento avanzado*",
    ADVANCE_ITEM: "Elemento avanzado*",
    EXECUTION_TYPES: "Tipo de ejecución*",
    ELEMENTS: "Elementos a medir*",
    TRACING: "Seguimiento",
    ORDER_CONDITION:
      "Presione editar para agregar condiciones sobre campos en la orden",
    BILLING_SESSIONS: "Sesiones de facturación",
    NEW_ORDER_TYPE: "Tipo de orden generada",
    NEW_ORDER_STATE: "Estado de orden generada",
    BILLING: "Activar facturación automática",
    FIXED: "Predeterminados",
    CUSTOM: "Personalizados",
    ORDER_PARAMS: "Parámetros orden",
    ADITIONAL_INFO: "Información adicional del servicio",
    SELECT_SESSIONS: "Buscar sesiones",
    SELECT_FORMS: "Buscar formularios",
    AVAILABILITY_COLOR: "Color disponibilidad",
    AVAILABILITY_RECURRENT: "Recurrencia máxima (en días)",
    CREATE_SESSION: "Crear sesión",
    CREATE_FORM: "Crear formulario",
    CREATE_CUPS: "Crear nivel de precios",
    CUPS_MODAL: "Nivel de precio",
    FORM_MODAL: "Formulario",
    SESSION_MODAL: "Sesión",
    CHARTS: {
      STATE: "Servicios por Estado",
      CATEGORY: "Servicios por Categoria",
      TYPE: "Servicios por Tipo"
    },
    IDS: {
      SAVE_SERVICE_ID: "saveServiceTemplate",
      SAVE_SERVICE_TEMPLATE: "saveServiceTemplateComponent",
      ADD_SECTION_GROUPS_COMPONENT: "addSectionGroupComponent",
      ADD_SECTION_GROUPS_CONTAINER: "addSectionGroupComponentContainer",
      ADD_SECTION_GROUP: "addSectionGroup"
    },
    MULTIPLE_SERVICES_LABEL: "Multiples instancias",
    ONLINE_APPOINTMENT: "Cita en línea",
    RDA_LABEL: "RDA",
    VERSION: "Versión: ",
    REQUIRE_PRIOR_ORDER: "Este CUPS requiere orden previa",
    NOT_REQUIRE_PRIOR_ORDER: "Este CUPS no requiere orden previa"
  },
  LABELS_RULE: {
    NAME: "Nombre de la regla*",
    DESCRIPTION: "Descripción*",
    TYPE: "Tipo de regla*",
    TITLE_CONDITIONS: "Condiciones",
    TITLE_TASKS: "Tareas",
    NOTIFICATIONS: "Notificaciones"
  },
  DELETE_MODAL: {
    TITLE: "Eliminar servicio",
    TEXT: "Ingrese la razón por la cual va a deshabilitar el servicio:"
  },
  SELECTED_FORMS: "Formularios seleccionados",
  SELECTED_SESSIONS: "Sesiones seleccionadas",
  FORMS: "Formularios",
  SESSIONS: "Sesiones",
  CATEGORY_LIST_NAME: "Categoría de servicios",
  ADD_TEXT: "Agregar",
  EDIT_TEXT: "Editar",
  TYPE: {
    GROUPS: "groups",
    SECTIONS: "sections"
  },
  TYPE_SHOW: {
    GROUPS: "grupos",
    SECTIONS: "secciones"
  },
  TITLE: {
    ADD_TEMPLATE: "Agregar servicio",
    EDIT_TEMPLATE: "Editar servicio",
    MAIN_TEMPLATE: "Consulta de servicio",
    GROUPS: "Grupos",
    SECTION: "Secciones",
    RULES: "Reglas",
    DIALOG_RULES: "Configuración de reglas",
    ADD_FORM_TEMP_TITLE: "Seleccionar tareas para el rol"
  },
  MODAL_TITLE: {
    GROUP: "grupo",
    SECTION: "sección"
  },
  MESSAGES: {
    ADD_FORM: "Formulario agregado",
    ADD_SESSION: "Sesión agregada",
    EXIST_FORM: "El formulario ya está agregado",
    EXIST_SESSION: "La sesión ya está agregada",
    INACTIVE_FORM: "No puede agregar formularios inactivos",
    SELECT_AT_LAST_ONE_AVAILABILITY: "Debe elegir al menos una disponibilidad",
    AVAILABILITY_CREATED: "Disponibilidad creada"
  },
  LABELS_CREATE_TEMP: {
    ICON: "Icono",
    NAME_OF: "Nombre ",
    CATEGORY: "Categoría*",
    DESCRIPTION: "Descripción",
    TYPE: "Tipo*",
    NAME: "Nombre del servicio*",
    ALIAS: "Alias*",
    SEARCH: "Buscar",
    CUPS: "CUPS*",
    FILL_BY_STEP_LABEL: "Llenar en secuencia "
  },
  BUTTONS_CREATE_TEMP: {
    PRICE_LEVEL: "Nivel de Precio",
    ADD_RULE: "Regla",
    ADD_FORMS: "Formularios",
    ADD_NOTIFICATIONS: "Notificaciones"
  },
  SNACKBAR_MESSAGES: {
    SAVE_SUCCESS: "Servicio guardado",
    CATEGORIES_NOT_FOUND: "Error al cargar la lista de categorías",
    NAME_EXIST: "Ya existe un servicio con ese nombre",
    CUPS_NO_FOUND: "No se encontraron cups activos",
    GROUP_RULE_FOUNDED:
      "Se encontró una regla asociada al grupo. Debe eliminar primero la regla para continuar",
    SESION_RULE_FOUNDED:
      "Se encontró una regla asociada a la sesión. Debe eliminar primero la regla para continuar",
    SERVICE_USED:
      "La plantilla de servicio no se puede eliminar porque está en uso",
    SECTION_WITHOUT_FORMS: "Debes agregar al menos un formulario",
    GROUP_WITHOUT_SESSION: "Debe agregar al menos una sessión",
    SECTION_ALREADY_EXISTS: "Ya existe una sección con ese nombre",
    GROUP_ALREADY_EXISTS: "Ya existe un grupo con ese nombre"
  },
  STATES: ["Activo", "Inactivo"],
  TYPE_FILTER: {
    SEARCH: "search",
    LOADING: "loading"
  },
  SERVICE_TYPE_LIST: [
    { label: "Secciones", value: "sections" },
    { label: "Grupos", value: "groups" }
  ],
  RULES_TYPE_LIST: [
    { label: "Tarea", value: "task" },
    { label: "Servicio", value: "service" },
    { label: "Orden", value: "order" }
  ],
  RULE_TYPES: {
    TASK: "task",
    SERVICE: "service",
    ORDER: "order"
  },
  RULE_MOMENT: {
    STATE: "state",
    SESSION: "session"
  },
  EMPTY_STATE: {
    GROUP: {
      HEADER: "No se han agregado grupos aún",
      TEXT: "Agrega grupos al servicio"
    },
    SECTION: {
      HEADER: "No se han agregado secciones aún",
      TEXT: "Agrega secciones al servicio"
    },
    SESSION: {
      HEADER: "No se han agregado sesiones aún",
      TEXT: "Agrega sesiones para el grupo"
    },
    FORMS: {
      HEADER: "No se han agregado plantillas de formularios aún",
      TEXT: "Agrega formularios para la sección"
    },
    RULES: {
      HEADER: "No se han agregado reglas aún",
      TEXT: "Agrega reglas al servicio"
    }
  },
  RULES_MESSAGE: {
    MIN_ONE_USER_TEMP: "Debe seleccionar al menos una plantilla"
  },
  CANCEL_RULE_MODAL: {
    TITLE: "Cancelar",
    MESSAGE:
      "¿Está seguro que desea Cancelar? Perderá la configuración ingresada"
  },
  ATTRIBUTES_CLIENTS: ["name", "price"],
  OPTIONS_PANEL: [
    {
      value: "showAddCups",
      srcImg: "search-session-temp.png",
      name: "Crear nivel de precios"
    },
    {
      value: "showAddForm",
      srcImg: "search-session-temp.png",
      name: "Crear formulario"
    },
    {
      value: "showAddSession",
      srcImg: "search-session-temp.png",
      name: "Crear sesión"
    }
  ],
  PANEL_OPTIONS_ACTIONS: {
    CUPS: "showAddCups",
    FORM: "showAddForm",
    SESSION: "showAddSession"
  }
};

export const EVENT_DATE_LIST = [
  { label: "Creación", value: "created" },
  { label: "Asignación", value: "assigned" },
  { label: "Cita", value: "scheduled" },
  { label: "Cancelación", value: "cancelled" }
];

export const EVENT_DATE_LIST_FOR_SECTION = [
  { label: "Creación", value: "created" },
  { label: "Asignación", value: "assigned" },
  { label: "Cita", value: "scheduled" }
];

export const GROUP_EXECUTION_TYPES = [
  { label: "Grupos", value: "groups" },
  { label: "Sesiones", value: "sessions" }
];

export const SECTION_EXECUTION_TYPES = [
  { label: "Secciones", value: "sections" },
  { label: "Plantillas de formulario", value: "formTemplates" }
];

export const PROGRESS_CONDITIONS = [
  { label: "Mayor que ...", value: ">" },
  { label: "Mayor o igual que ...", value: ">=" },
  { label: "Igual", value: "=" },
  { label: "Menor que ...", value: "<" },
  { label: "Menor o igual que ...", value: "<=" }
];

export const SERVICE_STATE = {
  groups: [
    "Sin Iniciar",
    "Sin asignar",
    "En progreso",
    "Completado",
    "Cancelado"
  ],
  sections: [
    "Sin Iniciar",
    "Sin asignar",
    "Asignado",
    "En progreso",
    "Completado",
    "Cancelado",
    "En espera"
  ]
};

export const PROGRESS_CONDITION_STATES = {
  IN_PROGRESS: "En progreso",
  ASSIGNED: "Asignado"
};

export const SERVICE_RULE_TYPE = {
  PROGRESS: { VALUE: "Por progreso", KEY: "advanceItem" },
  EXECUTION: { VALUE: "Por ejecución", KEY: "executeRule" }
};

export const TASK_STATE = ["Pendiente", "Completada", "Cancelada"];

export const SERVICE_TEMP_EVENTS = {
  CLOSE_STEPPER_VIEWER: "modalStepperViewerClose",
  CLOSE_MODAL_ADD_SECTION_GROUP: "closeDialog",
  SAVE_MODAL_ADD_SECTION_GROUP: "saveSectionGroup",
  UPDATE_MODAL_ADD_SECTION_GROUP: "updateSectionGroup",
  MODAL_SAVE_RULE: "modalSaveRule",
  MODAL_CANCEL_RULE: "modalCancelRule"
};

export const SUMMARY_RULES = {
  START: "La regla de tipo",
  CONFIG: "aplica para servicios",
  USERS: "que esten asociados a los usuarios:",
  USER_TEMPS: "que hayan sido creados con las plantillas:",
  STATE_SERVICE: "y el servicio se encuentre en estado",
  PRICE_LEVEL: "donde el nivel de precio sea",
  TASKS: "Las tareas asignadas serán:",
  FORMS_REQ: "Formularios obligatorios",
  FORMS_NO_REQ: "Formularios opcionales",
  TASKS_EVENT: "Estas tareas se activarán",
  BEFORE_DATE: "días antes de la fecha de",
  AFTER_DATE: "días después de la fecha de",
  BEFORE: "días antes",
  AFTER: "días después",
  TIME: "a las",
  SESSION: "de la sesión",
  EACH: "cada",
  DAYS: "días",
  GROUP: "del grupo",
  RECEIVED_BY_USER: "para los usuarios",
  RECEIVED_BY_TEMPS: "para los grupos de usuarios",
  NOTIFICATION: "Las notificaciones que se configuraron son:",
  PROGRESS_TYPE: "La regla aplicará <b>Por progreso</b> una vez el progreso",
  PROGRESS_SERVICE: "del <b>Servicio</b>",
  PROGRESS_SECTION: "de la <b>Sección</b>",
  PROGRESS_GROUP: "del <b>Grupo</b>",
  EXECUTION_TYPE:
    "La regla aplicará <b>Por ejecución</b> una vez se completen las siguientes",
  EXECUTION_TYPE_GROUPS: "grupos o sesiones",
  EXECUTION_TYPE_SECTIONS: "formularios o secciones",
  EXECUTE_GROUPS: "<br/><h4><i>Sesiones o grupos a ejecutar:</i></h4><ul>",
  EXECUTE_SESSIONS:
    "<br/><h4><i>Formularios o secciones a ejecutar:</i></h4><ul>",
  DIAGNOSTIC_CODE: "Código de diagnóstico",
  ORDER_TYPE: "Tipo de orden",
  ORDER_STATE: "Estado de la orden",
  BILLING_TYPE: "Tipo de facturación",
  ORDER_CONDITIONS:
    "La regla se ejecutará si se cumplen las siguientes condiciones sobre la orden",
  BILLING: "La regla tiene facturación automática por",
  SESSIONS: "Sesiones",
  SERVICE: "Servicio",
  GENERATE_ORDER: "Se generara una orden en estado",
  TYPE: "y de tipo",
  FOLLOWING_SESSIONS: "en las siguientes sesiones",
  SERVICE_STATE_BILLING: "una vez el estado del servicio sea"
};

export const RULE_INITIALIZATION: Rule = {
  name: "",
  description: "",
  moment: "",
  conditions: {
    userTemplate: [],
    serviceState: "",
    user: [],
    priceLevel: []
  },
  actions: {},
  notifications: [],
  type: ""
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Servicio",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE
  },
  {
    name: "Estado",
    placeholder: "Estado de Servicio",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  },
  {
    name: "Categoria",
    placeholder: "Categoria de Servicio",
    key: "category",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [] as {
      key: string;
      name: string;
    }[]
  },
  {
    name: "Tipo",
    placeholder: "Tipo de Servicio",
    key: "type",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      {
        name: SERVICE_TEMP_CONSTANTS.TYPE_SHOW.SECTIONS,
        key: SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS
      },
      {
        name: SERVICE_TEMP_CONSTANTS.TYPE_SHOW.GROUPS,
        key: SERVICE_TEMP_CONSTANTS.TYPE.GROUPS
      }
    ]
  }
];

export const SERVICE_TEMP_FILTERS: Filter[] = [
  {
    mainFilterKey: "all",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS,
    initial: true,
    placeholder:
      "Escriba el nombre del servicio o utiliza los filtros para agrupar información"
  }
];

export const SERVICE_FILTERS_NAMES = {
  NAME: "name",
  CATEGORY: "category",
  TYPE: "type",
  STATE: "state"
};

export const FORM_FILTERS_NAMES = {
  FORM_TEMPLATE: "formTemplate",
  NAME: "name"
};

export const SESSION_FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "session",
    mainFilterName: "Todos",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para las sesiones",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Sesion",
        key: SERVICE_FILTERS_NAMES.NAME,
        type: "secondaryFilter",
        display: "unique",
        default: false,
        operators: OPERATORS_FILTERS,
        avatar: "mdi-form-select",
        disabled: false
      }
    ]
  }
];

export const FORMS_FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "all",
    mainFilterName: "Todos",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para los formularios",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Formulario",
        key: FORM_FILTERS_NAMES.NAME,
        type: "secondaryFilter",
        display: FILTER_DISPLAY.UNIQUE,
        default: true,
        operators: OPERATORS_FILTERS,
        avatar: "mdi-form-textbox",
        disabled: false
      },
      {
        name: "Categoria",
        placeholder: "Categoria de Formulario",
        key: SERVICE_FILTERS_NAMES.CATEGORY,
        avatar: "mdi-shape",
        type: "secondaryFilter",
        disabled: true,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: FORM_CATEGORY.map(data => ({ key: data, name: data })),
        default: false
      }
    ]
  }
];

export const EMITS = {
  CANCEL: "cancel",
  CLOSE: "close"
};

export const BASIC_FILTERS = {
  SESSION: [{ name: "Nombre", value: "", id: "name", active: true }],
  FORMS: [
    { name: "Nombre", value: "", id: "name", active: true },
    { name: "Category", value: "", id: "category", active: true }
  ]
};

export const SERVICE_TEMPLATES_ACCESS = {
  GET: "consultar plantillas de servicio",
  POST: "crear plantillas de servicio",
  PUT: "modificar plantillas de servicio",
  DELETE: "eliminar plantillas de servicio"
};

export const MOVIL_VIEW_STEPPER_STYLE =
  " max-height: calc(100vh - 360px) ; padding-right:10px";
